import React from 'react';
import styles from './MspRegistrationPrompt.module.scss';
import { Link } from 'react-router';
import { Routes } from '~/shared/constants/routes.js';

const MspRegistrationPrompt = () => (
  <div className={styles.mspPrompt}>
    <div className={styles.circle}>
      <div className={styles.content}>
        <div className={styles.title}>Are you an MSP organization?</div>
        <div className={styles.subtext}>If so, please click here to register</div>
        <div className={styles.button}>
          <Link to={Routes.REGISTER_OLD_USER_MANAGEMENT} className={styles.link}>
            MSP Registration
          </Link>
        </div>
      </div>
    </div>
  </div>
);

export default MspRegistrationPrompt;
